import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IntegrationsApiAxiosParamCreator } from '../../../apis/integrations-api';
import { BaseApi } from '@/service/BaseApi';
import { RequestArgs } from 'base';
import { USER_STATUS } from '@/enum/constants';

export class IntegrationsApi extends BaseApi {

  /**
   * 
   * @summary Verify token for customer login
   * @param {string} token The token received to finalize registration process
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public static async verifyToken(token: string, options?: AxiosRequestConfig) { //v2 api 
    const axiosArgs = await IntegrationsApiAxiosParamCreator().verifyToken(token, options);
    
    const response = this.getAuthorizedAxios().request({
      url: axiosArgs.url,
      method: axiosArgs.options.method,
      headers: axiosArgs.options.headers,
      params: axiosArgs.options.params,
      data: axiosArgs.options.data,
    });
    const responseToken = (await response).data.value;
    localStorage.setItem('t', JSON.stringify(responseToken))
    localStorage.setItem('auth', USER_STATUS.LOG_IN);
  }
}
